import { useAtom } from 'jotai';
import { hoveredMapAreaAtom } from '../states/planner';
import { storageUrl } from '../firebase';
import useMaps from '../hooks/useMaps';
import { useEffect, useRef, useState, useCallback } from 'react';
import { getAnchor } from './CustomShapeArea';

export const AreaMapHover = () => {
  const [hoveredArea] = useAtom(hoveredMapAreaAtom);
  const [tooltipSize, setTooltipSize] = useState({ width: 0, height: 0 });
  const tooltipRef = useRef<HTMLDivElement>(null);
  const [maps] = useMaps();

  const updateSize = useCallback(() => {
    if (tooltipRef.current?.parentElement) {
      const parent = tooltipRef.current.parentElement;
      const { offsetWidth, offsetHeight } = tooltipRef.current;

      setTooltipSize({
        width: (offsetWidth / parent.offsetWidth) * 100,
        height: (offsetHeight / parent.offsetHeight) * 100,
      });
    }
  }, []);

  useEffect(() => {
    if (!tooltipRef.current?.parentElement) return;
    const parent = tooltipRef.current.parentElement;

    updateSize();

    const observer = new ResizeObserver(updateSize);
    observer.observe(parent);

    return () => observer.disconnect();
  }, [hoveredArea, updateSize]);

  if (!hoveredArea) return null;

  const map = maps[Number(hoveredArea.reference_id)];
  if (!map) return null;

  const picture = map.imageurl;
  const name = map.name;
  const svgArea = hoveredArea;

  const tooltipplace = svgArea.tooltipplace;
  const anchor = getAnchor(tooltipplace, svgArea, tooltipSize);

  return (
    <div
      ref={tooltipRef}
      className={`z-2 pointer-events-none absolute transform rounded-md bg-white shadow-lg transition-all duration-300 ease-out ${
        hoveredArea ? 'visible scale-100 opacity-95' : 'invisible scale-75 opacity-0'
      }`}
      style={{
        top: `${anchor.y}%`,
        left: `${anchor.x}%`,
      }}
    >
      {tooltipplace === 'top' && (
        <div className="absolute left-1/2 top-full -translate-x-1/2 border-x-[7px] border-t-[7px] border-x-transparent border-t-white opacity-90" />
      )}
      {tooltipplace === 'bottom' && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 border-x-[7px] border-b-[7px] border-x-transparent border-b-white opacity-90" />
      )}
      {tooltipplace === 'left' && (
        <div className="absolute left-full top-1/2 -translate-y-1/2 border-y-[7px] border-l-[7px] border-y-transparent border-l-white opacity-90" />
      )}
      {tooltipplace === 'right' && (
        <div className="absolute right-full top-1/2 -translate-y-1/2 border-y-[7px] border-r-[7px] border-y-transparent border-r-white opacity-90" />
      )}
      <div className="min-h-56 w-64">
        <div className="p-2">
          <img src={storageUrl(picture)} alt="floorplanpicture" onLoad={updateSize} />
        </div>
        <div className="mb-3 text-center text-base">{name}</div>
      </div>
    </div>
  );
};
